import { Star } from "lucide-react";
import { cn } from "@project/lib/utils";

const MAX_STARS = 5;

type StarRatingProps = {
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  readOnly?: boolean;
  size?: "sm" | "md";
  className?: string;
};

export function StarRating({
  value,
  onChange,
  disabled = false,
  readOnly = false,
  size = "md",
  className,
}: StarRatingProps) {
  const rating = Math.min(MAX_STARS, Math.max(0, Number(value) || 0));
  const iconSize = size === "sm" ? "h-4 w-4" : "h-6 w-6";

  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {Array.from({ length: MAX_STARS }, (_, i) => i + 1).map(star => {
        const filled = star <= rating;
        if (readOnly || disabled || !onChange) {
          return (
            <Star
              key={star}
              className={cn(
                iconSize,
                filled ? "fill-gold text-gold" : "text-muted-foreground/40"
              )}
            />
          );
        }
        return (
          <button
            key={star}
            type="button"
            disabled={disabled}
            onClick={() => onChange(star)}
            className="rounded p-0.5 transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50"
            aria-label={`Rate ${star} out of ${MAX_STARS}`}
          >
            <Star
              className={cn(
                iconSize,
                filled ? "fill-gold text-gold" : "text-muted-foreground"
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
